/* fb-product.js — PDP recommendations right-column. Fetches fb-rec-list (Shopify
   Product Recommendations engine, server-rendered fb-rec-card with review stars)
   seeded by the current product, and handles the "+" quick-add. Document-delegated
   and scoped so it never collides with the side cart's own handler. */
(function () {
  'use strict';
  var SECTION = 'fb-rec-list';

  function fetchCards(pid, intent) {
    return window.fetch('/recommendations/products?section_id=' + SECTION + '&product_id=' + pid + '&intent=' + intent + '&limit=6', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { var d = new DOMParser().parseFromString(html, 'text/html'); var box = d.querySelector('[data-fb-rec-cards]'); return box ? box.innerHTML : ''; })
      .catch(function () { return ''; });
  }

  // Hand the cards to fb-commerce's quick-buy system: the "+" becomes a real
  // [data-quick-buy] button, so adding flies the photo to the cart and swaps the
  // button for the same navy [ − N + ] stepper the home/grid cards use (the card
  // stays in place; at qty 0 the stepper reverts to the button).
  function adoptQuickBuy(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('.fb-rec-card'), function (card) {
      var b = card.querySelector('[data-fb-rec-add]');
      var vid = card.getAttribute('data-vid');
      if (!b || !vid) return;
      b.removeAttribute('data-fb-rec-add');
      b.setAttribute('data-quick-buy', '');
      b.setAttribute('data-variant-id', vid);
    });
    if (window.fbQuickBuy) window.fbQuickBuy.refresh(); // paint steppers for in-cart items
  }

  function initColumn() {
    var col = document.querySelector('[data-fb-pdp-recs-col]');
    if (col) {
      var pid = col.getAttribute('data-product-id');
      var list = col.querySelector('[data-fb-pdp-recs]');
      if (pid && list) {
        fetchCards(pid, 'complementary')
          .then(function (h) { if (h && /fb-rec-card/.test(h)) return h; return fetchCards(pid, 'related'); })
          .then(function (h) { if (h && /fb-rec-card/.test(h)) { list.innerHTML = h; adoptQuickBuy(list); col.hidden = false; } });
      }
    }
    // any leftover server-rendered bottom recommendations section gets the same treatment
    Array.prototype.forEach.call(document.querySelectorAll('[data-product-recommendations]'), adoptQuickBuy);
  }


  /* ---- Sticky gallery guard. The gallery column is pinned on desktop (see
     fb-product.css), which only reads well while the whole gallery fits on
     screen. 198 of the 201 products are square photos (~520px tall) and fit
     anywhere; a handful of portrait bottle shots run past the viewport, and
     pinning those would park their lower half permanently off-screen. Measure
     against the same offset the CSS uses and let the stylesheet decide. ---- */
  function initStickyGallery() {
    var outer = document.querySelector('.product--outer');
    var gallery = outer && outer.querySelector('.product-gallery');
    if (!gallery) return;
    function measure() {
      var top = parseFloat(getComputedStyle(outer).getPropertyValue('--fb-pdp-sticky-top')) || 0;
      var fits = gallery.getBoundingClientRect().height + top + 24 <= window.innerHeight;
      outer.classList.toggle('fb-pdp--gallery-tall', !fits);
    }
    measure();
    // the swiper settles after init and images decode late — re-measure on both
    if (window.ResizeObserver) new ResizeObserver(measure).observe(gallery);
    window.addEventListener('resize', measure);
  }


  /* ---- La ficha técnica llega como carrusel: el bloque imprime la misma
     lista TRES veces para que la animación cierre el ciclo sin salto. En
     escritorio se queda quieta en dos columnas (fb-product.css), y ahí las
     repeticiones sacarían cada dato tres veces. Se marcan una sola vez al
     cargar y el CSS decide si se ven, así el carrusel de móvil queda intacto.
     Si el conteo no es múltiplo de tres el patrón cambió: no se toca nada. ---- */
  function initMetaGrid() {
    var inner = document.querySelector('.product--outer .marquee__inner');
    if (!inner) return;
    var kids = inner.children, n = kids.length;
    if (n < 3 || n % 3 !== 0) return;
    for (var i = n / 3; i < n; i++) kids[i].classList.add('fb-meta-repeat');
  }


  /* ---- El − + no existe hasta que el producto ya está en el carrito.

     Antes de agregar no controla nada real: sugiere que ya estás sumando cosas
     cuando todavía no pasa nada. Así que el botón va solo. Una vez agregado, el
     botón se va y queda el − +, que ahí sí manda — edita la línea del carrito
     de verdad, no "cuántos voy a agregar".

     Solo de 750px para arriba. Abajo manda la barra fija de compra, que espeja
     estos mismos controles: mover uno sin el otro los desincroniza. El JS nada
     más marca el estado en data-fb-qty-mode; quién se ve lo decide el CSS.

     No intercepta los clicks del ± del tema: lo deja mover el input y solo mira
     el resultado. Menos superficie de choque con el tema. ---- */
  function initQtyEnCarrito() {
    var caja = document.querySelector('.product--outer .product-form--atc');
    if (!caja) return;
    var form = caja.closest('form');
    var input = caja.querySelector('[data-quantity-input]');
    if (!form || !input) return;

    var aviso = document.createElement('a');
    aviso.className = 'fb-encarrito';
    aviso.href = '/cart';
    aviso.innerHTML = '<span>Ya está en tu carrito.</span> <b>Ver carrito</b>';
    caja.appendChild(aviso);

    var lineaId = null;     // clave de la línea en el carrito
    var aplicando = false;  // evita que nuestro propio set del input rebote

    // el estado arranca en "add" de una vez: si esperamos a /cart.js, el ± se
    // alcanza a ver y desaparece. Si el fetch falla, se queda así y el botón
    // solo es exactamente lo que queremos de todos modos.
    caja.setAttribute('data-fb-qty-mode', 'add');

    function varianteActual() {
      var v = form.querySelector('[name="id"]');
      return v ? String(v.value) : null;
    }

    // El − no baja de 1 ni en modo carrito: la última pieza se quita en el cajón
    // (X, o mantener presionado el −), igual que en el resto del sitio. Con min=0
    // un toque de más en el − de la barra borraba la línea sin aviso.
    var minOriginal = input.getAttribute('min') || '1';

    function sincronizarMenos() {
      var caja_menos = caja.querySelector('[data-button-wrapper-minus]');
      if (!caja_menos) return;
      var min = parseInt(input.getAttribute('min'), 10); if (isNaN(min)) min = 1;
      var v = parseInt(input.value, 10); if (isNaN(v)) v = min;
      caja_menos.classList.toggle('quantity-selector__button-wrapper--disabled', v <= min);
    }

    // Aviso cuando el servidor rechaza el cambio. En escritorio se pinta bajo el ±;
    // en móvil ese bloque está oculto y lo muestra la barra fija (fb-pdp-sticky-atc).
    var avisoEl = null, avisoT = null;
    function avisar(err) {
      var msg = (err && (err.description || err.message)) || '';
      if (!msg || /^cart error$/i.test(msg) || err && err.status === 'bad_request') msg = 'No pudimos actualizar tu carrito. Intenta de nuevo.';
      if (!avisoEl) {
        avisoEl = document.createElement('p');
        avisoEl.className = 'fb-qty-aviso';
        avisoEl.setAttribute('role', 'status');
        caja.appendChild(avisoEl);
      }
      avisoEl.textContent = msg;
      avisoEl.hidden = false;
      if (avisoT) window.clearTimeout(avisoT);
      avisoT = window.setTimeout(function () { avisoEl.hidden = true; }, 5000);
      document.dispatchEvent(new CustomEvent('fb:cart-aviso', { bubbles: true, detail: { msg: msg } }));
    }

    var ultimoEnviado = null; // cantidad que el servidor ya tiene (o va en camino)
    var ultimaLinea = null;   // la línea del carrito tal como la devolvió el servidor (para Deshacer)

    function respuesta(r) {
      return r.ok ? r.json() : r.json().then(function (e) { throw e; }, function () { throw { status: r.status }; });
    }

    function pintar(qty, key) {
      lineaId = key;
      aplicando = true;
      input.value = qty > 0 ? qty : minOriginal;
      aplicando = false;
      ultimoEnviado = qty > 0 ? qty : null;
      caja.setAttribute('data-fb-qty-mode', qty > 0 ? 'cart' : 'add');
      sincronizarMenos();
      // `input.value = n` no dispara ningún evento: la barra fija espejea este
      // input y sin esto se quedaba con el número atrasado.
      input.dispatchEvent(new CustomEvent('fb:qty-sync', { bubbles: true, detail: { qty: qty, key: key } }));
    }

    function buscaLinea(c) {
      var vid = varianteActual(), linea = null;
      if (!vid) return null;
      (c && c.items || []).forEach(function (it) {
        if (!linea && String(it.variant_id) === vid) linea = it;
      });
      return linea;
    }

    function leerCarrito(cart) {
      if (!varianteActual()) return;
      if (cart && cart.items) { var l = buscaLinea(cart); ultimaLinea = l; pintar(l ? l.quantity : 0, l ? l.key : null); return; }
      window.fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { var l = buscaLinea(c); ultimaLinea = l; pintar(l ? l.quantity : 0, l ? l.key : null); })
        .catch(function () {}); // sin respuesta no se cambia de modo: el input podría traer la cantidad del carrito
    }

    /* Los cambios viajan en fila, uno a la vez, y cada paso manda el valor ACTUAL del
       input, no el que había cuando se tocó: tres toques seguidos se vuelven una o dos
       peticiones y nunca llegan en desorden. La clave de la línea se toma de cada
       respuesta, porque Shopify la recalcula cuando cambia el descuento (por volumen).
       Antes: un POST por toque, en paralelo, sin leer la respuesta ni el error. */
    var cola = Promise.resolve(), pendientes = 0, enVuelo = false;

    function paso() {
      pendientes--;
      if (caja.getAttribute('data-fb-qty-mode') !== 'cart' || !lineaId) return;
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1 || n === ultimoEnviado) return;
      ultimoEnviado = n;
      enVuelo = true;
      return window.fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineaId, quantity: n })
      })
        .then(respuesta)
        .then(function (cart) {
          var l = buscaLinea(cart);
          ultimaLinea = l;
          if (pendientes === 0) pintar(l ? l.quantity : 0, l ? l.key : null); // nadie tocó mientras tanto
          else { lineaId = l ? l.key : null; ultimoEnviado = l ? l.quantity : null; }
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function (err) {
          avisar(err);
          ultimoEnviado = null;
          if (pendientes === 0) leerCarrito(); // volver a lo que el servidor sí tiene
        })
        .then(function () { enVuelo = false; });
    }

    input.addEventListener('change', function () {
      if (aplicando) return;
      if (caja.getAttribute('data-fb-qty-mode') !== 'cart') return;
      pendientes++;
      cola = cola.then(paso).catch(function () {});
    });

    /* Quitar la línea desde la barra fija (bote de basura a 1 pieza). Va por la misma fila
       que los cambios. Al terminar avisa con fb:cart-undo: la barra muestra "Deshacer" y
       ese botón vuelve a agregar la misma línea (variante, cantidad, plan y propiedades). */
    function deshacer(linea) {
      var body = { id: linea.variant_id, quantity: linea.quantity };
      if (linea.properties && Object.keys(linea.properties).length) body.properties = linea.properties;
      if (linea.selling_plan_allocation && linea.selling_plan_allocation.selling_plan) body.selling_plan = linea.selling_plan_allocation.selling_plan.id;
      window.fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(respuesta)
        .then(function () { return window.fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          leerCarrito(cart);
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        })
        .catch(function (err) { avisar(err); leerCarrito(); });
    }
    input.addEventListener('fb:qty-remove', function () {
      if (caja.getAttribute('data-fb-qty-mode') !== 'cart' || !lineaId) return;
      var linea = ultimaLinea;
      pendientes++;
      cola = cola.then(function () {
        pendientes--;
        if (!lineaId) return;
        enVuelo = true;
        return window.fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lineaId, quantity: 0 })
        })
          .then(respuesta)
          .then(function (cart) {
            ultimaLinea = null;
            pintar(0, null);
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
            if (linea) document.dispatchEvent(new CustomEvent('fb:cart-undo', { bubbles: true, detail: {
              msg: 'Se quitó ' + (linea.product_title || 'el producto') + '.',
              undo: function () { deshacer(linea); }
            } }));
          })
          .catch(function (err) { avisar(err); leerCarrito(); })
          .then(function () { enVuelo = false; });
      }).catch(function () {});
    });

    leerCarrito();
    // Un solo evento; si trae el carrito (fb-commerce, el cajón, este guion) no se vuelve
    // a pedir /cart.js. Mientras hay un cambio nuestro en vuelo se ignora: ya lo pintamos.
    document.addEventListener('cart:updated', function (e) {
      if (enVuelo || pendientes > 0) return;
      var cart = e && e.detail && e.detail.cart;
      if (cart && cart.items) leerCarrito(cart);
      else window.setTimeout(leerCarrito, 60);
    });
    // cambiar de variante cambia cuál es la línea que manda
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') leerCarrito();
    });
  }


  /* ---- Tope de existencias en el selector de cantidad.

     fb-qty.js ya recorta contra el atributo `max` del input, pero el tema nunca
     lo escribía: se podía marcar 20 piezas de algo que tiene 3 y enterarse hasta
     el "Agregar". El inventario por variante lo imprime fb-pdp-stock.liquid; aquí
     se aplica el de la variante elegida y se recorta el valor si venía más alto.

     Los demás ± del sitio (tarjetas, cajón del carrito, página del carrito) pasan
     por /cart/change.js y repintan con lo que devuelve el servidor, así que no
     pueden enseñar más de lo que el carrito realmente tiene. El de la ficha era
     el único que decidía solo. ---- */
  function initTopeStock() {
    var datos = document.querySelector('.product--outer [data-fb-stock]');
    var caja = document.querySelector('.product--outer .product-form--atc');
    if (!datos || !caja) return;
    var form = caja.closest('form');
    var input = caja.querySelector('[data-quantity-input]');
    if (!form || !input) return;
    var stock;
    try { stock = JSON.parse(datos.textContent); } catch (e) { return; }

    function aplicar() {
      var v = form.querySelector('[name="id"]');
      var tope = v ? stock[String(v.value)] : undefined;
      // sin inventario controlado, o agotado (ahí manda el botón deshabilitado)
      if (typeof tope !== 'number' || tope <= 0) { input.removeAttribute('max'); return; }
      input.setAttribute('max', String(tope));
      var actual = parseInt(input.value, 10);
      if (!isNaN(actual) && actual > tope) {
        input.value = tope;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    aplicar();
    form.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') aplicar();
    });
  }

  function init() { initColumn(); initStickyGallery(); initMetaGrid(); initTopeStock(); initQtyEnCarrito(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
